// This file is auto-generated by @hey-api/openapi-ts

import type {
  Options as ClientOptions,
  TDataShape,
  Client,
} from '@hey-api/client-fetch'
import type {
  CollectFreeGcData,
  CollectFreeGcError,
  GetStateData,
  GetStateResponse,
  GetStateError,
  GetConfigurationData,
  GetConfigurationResponse,
  GetConfigurationError,
} from './types.gen'
import { client as _heyApiClient } from './client.gen'

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = ClientOptions<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>
}

/**
 * Collect Free GC
 */
export const collectFreeGc = <ThrowOnError extends boolean = false>(
  options?: Options<CollectFreeGcData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).put<
    unknown,
    CollectFreeGcError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/v1/self/endless-gc',
    ...options,
  })
}

/**
 * Account balance
 */
export const getTokensState = <ThrowOnError extends boolean = false>(
  options?: Options<GetStateData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetStateResponse,
    GetStateError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/v1/self',
    ...options,
  })
}

/**
 * Get endless GC configuration
 */
export const getFreeGcConfiguration = <ThrowOnError extends boolean = false>(
  options?: Options<GetConfigurationData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetConfigurationResponse,
    GetConfigurationError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/v1/endless-gc-config',
    ...options,
  })
}
